import { Cos } from './cos'

class Huaweiads {
    #COS;
    constructor(prefix = '/Huaweiads/*', path = '/Huaweiads/Attachment2222') {
        this.#COS = new Cos({
            prefix,
            path
        })
    }

    async putObject(file, options) {
        return await this.#COS.putObject(file, options)
    }
    
    getBasePrefix() {
        return this.#COS.basePrefix;
    }
    
    cancelTask(id) {
        return this.#COS.cancelTask(id)
    }
}
export default new Huaweiads();